module.exports = __webpack_public_path__ + "img/basico.27975a5c.gif";